module.exports = __webpack_public_path__ + "static/media/H2.31e4315e.png";